"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CSATCard = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireWildcard(require("react"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _clsx = _interopRequireDefault(require("clsx"));
var _LocaleProvider = require("../LocaleProvider");
var _badActive = _interopRequireDefault(require("../../assets/images/bad-active.png"));
var _badInactive = _interopRequireDefault(require("../../assets/images/bad-inactive.png"));
var _averageActive = _interopRequireDefault(require("../../assets/images/average-active.png"));
var _averageInactive = _interopRequireDefault(require("../../assets/images/average-inactive.png"));
var _goodActive = _interopRequireDefault(require("../../assets/images/good-active.png"));
var _goodInactive = _interopRequireDefault(require("../../assets/images/good-inactive.png"));
var _bubbleArrow = _interopRequireDefault(require("../../assets/images/bubble-arrow.svg"));
var _Button = require("../Button");
var _useTracking = require("../../hooks/useTracking");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var CSATFeedbackSelectorMode;
(function (CSATFeedbackSelectorMode) {
  CSATFeedbackSelectorMode["multiple"] = "multiple";
})(CSATFeedbackSelectorMode || (CSATFeedbackSelectorMode = {}));
var FeedbackType;
(function (FeedbackType) {
  FeedbackType[FeedbackType["GOOD"] = 1] = "GOOD";
  FeedbackType[FeedbackType["AVERAGE"] = 2] = "AVERAGE";
  FeedbackType[FeedbackType["BAD"] = 3] = "BAD";
})(FeedbackType || (FeedbackType = {}));
var CSATFeedbackSelectorType;
(function (CSATFeedbackSelectorType) {
  CSATFeedbackSelectorType[CSATFeedbackSelectorType["ADD"] = 0] = "ADD";
  CSATFeedbackSelectorType[CSATFeedbackSelectorType["DELETE"] = 1] = "DELETE";
})(CSATFeedbackSelectorType || (CSATFeedbackSelectorType = {}));
var InquiryResolvedOptions = [{
  label: 'label_yes_csat',
  value: 1
}, {
  label: 'label_no_csat',
  value: 2
}];
var CSATFeedbackOptionItem = function CSATFeedbackOptionItem(props) {
  var text = props.text,
    feedbackType = props.feedbackType,
    active = props.active,
    onClick = props.onClick;
  var imgSrc = (0, _react.useMemo)(function () {
    if (active) {
      switch (feedbackType) {
        case FeedbackType.AVERAGE:
          return _averageActive.default;
        case FeedbackType.BAD:
          return _badActive.default;
        case FeedbackType.GOOD:
          return _goodActive.default;
        default:
          return _averageActive.default;
      }
    } else {
      switch (feedbackType) {
        case FeedbackType.AVERAGE:
          return _averageInactive.default;
        case FeedbackType.BAD:
          return _badInactive.default;
        case FeedbackType.GOOD:
          return _goodInactive.default;
        default:
          return _averageInactive.default;
      }
    }
  }, [active, feedbackType]);
  var handleClick = function handleClick() {
    onClick === null || onClick === void 0 ? void 0 : onClick(feedbackType);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    onClick: handleClick,
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('csat-feedback-option-item'))
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('csat-feedback-option-item-icon')),
    src: imgSrc
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _clsx.default)(active ? (0, _getPrefixCls.getPrefixCls)('csat-feedback-option-item-active-text') : (0, _getPrefixCls.getPrefixCls)('csat-feedback-option-item-inactive-text'))
  }, text));
};
var CSATFeedbackSelector = function CSATFeedbackSelector(props) {
  var _useLocale = (0, _LocaleProvider.useLocale)(),
    trans = _useLocale.trans;
  var keyOptions = props.keyOptions,
    selectedKeys = props.selectedKeys,
    onSelect = props.onSelect,
    mode = props.mode;
  var handleClickKey = function handleClickKey(option) {
    var newSelectedKeys = (0, _toConsumableArray2.default)(selectedKeys);
    var csatFeedbackSelectorType = CSATFeedbackSelectorType.ADD;
    if (mode === CSATFeedbackSelectorMode.multiple) {
      if (selectedKeys.map(function (i) {
        return i.value;
      }).includes(option.value)) {
        newSelectedKeys = newSelectedKeys.filter(function (i) {
          return i.value !== option.value;
        });
        csatFeedbackSelectorType = CSATFeedbackSelectorType.DELETE;
      } else {
        newSelectedKeys.push(option);
        csatFeedbackSelectorType = CSATFeedbackSelectorType.ADD;
      }
    } else {
      newSelectedKeys = [option];
    }
    onSelect(option, newSelectedKeys, csatFeedbackSelectorType);
  }; // 满足 2 * 2 布局

  var renderKeyOptions = (0, _react.useMemo)(function () {
    var options = [];
    keyOptions.forEach(function (option, index) {
      if (index % 2 === 0) {
        if (keyOptions[index + 1]) {
          options.push([option, keyOptions[index + 1]]);
        } else {
          options.push([option]);
        }
      }
    });
    return options;
  }, [keyOptions]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('csat-feedback-key-items'))
  }, renderKeyOptions.map(function (options, idx) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: idx,
      className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('csat-feedback-key-items-row'))
    }, options.map(function (option, idx) {
      var _trans;
      return /*#__PURE__*/_react.default.createElement("span", {
        key: idx,
        onClick: function onClick() {
          return handleClickKey(option);
        },
        className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('csat-feedback-key-item'), selectedKeys.map(function (i) {
          return i.value;
        }).includes(option.value) ? (0, _getPrefixCls.getPrefixCls)('csat-feedback-key-item-active') : (0, _getPrefixCls.getPrefixCls)('csat-feedback-key-item-inactive'))
      }, (_trans = trans(option.label)) !== null && _trans !== void 0 ? _trans : option.label);
    }));
  }));
}; // @jiamin TODO trans

var CSATCard = function CSATCard(props) {
  var _trans2;
  var avatar = props.avatar,
    onLeave = props.onLeave,
    onSubmit = props.onSubmit,
    onFeedbackOptionClick = props.onFeedbackOptionClick,
    feedbackKeyOptions = props.feedbackKeyOptions,
    _props$withResolved = props.withResolved,
    withResolved = _props$withResolved === void 0 ? false : _props$withResolved,
    componentTrackingData = props.componentTrackingData;
  var _useLocale2 = (0, _LocaleProvider.useLocale)(),
    trans = _useLocale2.trans;
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    selectedFeedback = _useState2[0],
    setSelectedFeedback = _useState2[1];
  var selectedFeedbackRef = (0, _react.useRef)();
  var _useState3 = (0, _react.useState)([]),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    selectedFeedbackKeys = _useState4[0],
    setSelectedFeedbackKeys = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    selectedInquiryResolve = _useState6[0],
    setSelectedInquiryResolve = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    showSubmit = _useState8[0],
    setShowSubmit = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
    showInquiryResolved = _useState10[0],
    setShowInquiryResolved = _useState10[1];
  var _useComponentTracking = (0, _useTracking.useComponentTracking)({
      componentTrackingData: props.componentTrackingData
    }),
    tracker = _useComponentTracking.tracker,
    _useComponentTracking2 = _useComponentTracking.result,
    CSATCard_face = _useComponentTracking2.CSATCard_face,
    CSATCard_submit = _useComponentTracking2.CSATCard_submit,
    CSATCard_choose_reason = _useComponentTracking2.CSATCard_choose_reason,
    CSATCard_choose_resolution = _useComponentTracking2.CSATCard_choose_resolution,
    CSATCard_cancel_reason = _useComponentTracking2.CSATCard_cancel_reason;
  var handleClickFeedBackItem = function handleClickFeedBackItem(feedbackType) {
    var _CSATCard_face$tracki, _componentTrackingDat, _componentTrackingDat2;
    setShowSubmit(true);
    setSelectedFeedback(feedbackType);
    onFeedbackOptionClick === null || onFeedbackOptionClick === void 0 ? void 0 : onFeedbackOptionClick(feedbackType);
    (CSATCard_face === null || CSATCard_face === void 0 ? void 0 : CSATCard_face.trackingClick) && tracker.click(_objectSpread(_objectSpread({}, CSATCard_face.trackingClick), {}, {
      data: _objectSpread(_objectSpread({}, (_CSATCard_face$tracki = CSATCard_face.trackingClick) === null || _CSATCard_face$tracki === void 0 ? void 0 : _CSATCard_face$tracki.data), componentTrackingData === null || componentTrackingData === void 0 ? void 0 : (_componentTrackingDat = componentTrackingData.CSATCard_face) === null || _componentTrackingDat === void 0 ? void 0 : (_componentTrackingDat2 = _componentTrackingDat.trackingItemData) === null || _componentTrackingDat2 === void 0 ? void 0 : _componentTrackingDat2.call(_componentTrackingDat, {
        selectedFeedback: feedbackType
      }))
    }));
  };
  (0, _react.useEffect)(function () {
    selectedFeedbackRef.current = selectedFeedback;
  }, [selectedFeedback]);
  (0, _react.useEffect)(function () {
    if (selectedFeedback && withResolved) {
      setShowInquiryResolved(true);
    } else {
      setShowInquiryResolved(false);
    }
  }, [selectedFeedback, withResolved]);
  var keyOptions = (0, _react.useMemo)(function () {
    if (selectedFeedback === FeedbackType.BAD || selectedFeedback === FeedbackType.AVERAGE) {
      return feedbackKeyOptions.map(function (option) {
        return {
          label: option.reason,
          value: option.reason_id
        };
      });
    } else {
      return [];
    }
  }, [selectedFeedback]);
  var csatCardTalking = (0, _react.useMemo)(function () {
    if (selectedFeedback === FeedbackType.GOOD) {
      return 'label_chatbot_feedback_content_good';
    } else if (selectedFeedback === FeedbackType.AVERAGE) {
      return 'label_chatbot_feedback_content_avg';
    } else if (selectedFeedback === FeedbackType.BAD) {
      return 'label_chatbot_feedback_content_bad';
    }
    return 'label_chatbot_feedback_content_new';
  }, [selectedFeedback]);
  var handleClickSubmit = function handleClickSubmit() {
    var _selectedInquiryResol;

    // 和旧csat reasonId顺序的逻辑保持一致
    var reasonIds = [];
    var reasons = [];
    var selectedFeedbackKeysValues = selectedFeedbackKeys.map(function (i) {
      return i.value;
    });
    feedbackKeyOptions.forEach(function (i) {
      if (selectedFeedbackKeysValues.includes(i.reason_id)) {
        reasonIds.push(i.reason_id);
        reasons.push(trans(i.reason));
      }
    });
    var rateInfos = {
      rating: selectedFeedback ? selectedFeedback : undefined,
      resolved: (_selectedInquiryResol = selectedInquiryResolve[0]) === null || _selectedInquiryResol === void 0 ? void 0 : _selectedInquiryResol.value,
      reason: selectedFeedbackKeys.length ? reasons.join(',') : undefined,
      reason_id: selectedFeedbackKeys.length ? reasonIds.join(',') : undefined
    };
    if (selectedFeedback === FeedbackType.GOOD) {
      delete rateInfos.reason;
      delete rateInfos.reason_id;
    }
    onSubmit(rateInfos);
    (CSATCard_submit === null || CSATCard_submit === void 0 ? void 0 : CSATCard_submit.trackingClick) && tracker.click(CSATCard_submit.trackingClick);
  };
  var handleClickLeave = function handleClickLeave() {
    onLeave();
  };
  var handleSelectFeedbackKeys = function handleSelectFeedbackKeys(value, values, type) {
    setSelectedFeedbackKeys(values);
    var location = keyOptions.findIndex(function (i) {
      return i.value === value.value;
    });
    if (type === CSATFeedbackSelectorType.ADD) {
      var _CSATCard_choose_reas, _componentTrackingDat3, _componentTrackingDat4;
      (CSATCard_choose_reason === null || CSATCard_choose_reason === void 0 ? void 0 : CSATCard_choose_reason.trackingClick) && tracker.click(_objectSpread(_objectSpread({}, CSATCard_choose_reason.trackingClick), {}, {
        data: _objectSpread(_objectSpread({}, (_CSATCard_choose_reas = CSATCard_choose_reason.trackingClick) === null || _CSATCard_choose_reas === void 0 ? void 0 : _CSATCard_choose_reas.data), componentTrackingData === null || componentTrackingData === void 0 ? void 0 : (_componentTrackingDat3 = componentTrackingData.CSATCard_choose_reason) === null || _componentTrackingDat3 === void 0 ? void 0 : (_componentTrackingDat4 = _componentTrackingDat3.trackingItemData) === null || _componentTrackingDat4 === void 0 ? void 0 : _componentTrackingDat4.call(_componentTrackingDat3, _objectSpread(_objectSpread({}, value), {}, {
          location: location
        })))
      }));
    } else if (type === CSATFeedbackSelectorType.DELETE) {
      var _CSATCard_cancel_reas, _componentTrackingDat5, _componentTrackingDat6;
      (CSATCard_cancel_reason === null || CSATCard_cancel_reason === void 0 ? void 0 : CSATCard_cancel_reason.trackingClick) && tracker.click(_objectSpread(_objectSpread({}, CSATCard_cancel_reason.trackingClick), {}, {
        data: _objectSpread(_objectSpread({}, (_CSATCard_cancel_reas = CSATCard_cancel_reason.trackingClick) === null || _CSATCard_cancel_reas === void 0 ? void 0 : _CSATCard_cancel_reas.data), componentTrackingData === null || componentTrackingData === void 0 ? void 0 : (_componentTrackingDat5 = componentTrackingData.CSATCard_cancel_reason) === null || _componentTrackingDat5 === void 0 ? void 0 : (_componentTrackingDat6 = _componentTrackingDat5.trackingItemData) === null || _componentTrackingDat6 === void 0 ? void 0 : _componentTrackingDat6.call(_componentTrackingDat5, _objectSpread(_objectSpread({}, value), {}, {
          location: location
        })))
      }));
    }
  };
  var handleSelectFeedbackResolvedOptions = function handleSelectFeedbackResolvedOptions(value, values) {
    var _CSATCard_choose_reso, _componentTrackingDat7, _componentTrackingDat8;
    setSelectedInquiryResolve(values);
    (CSATCard_choose_resolution === null || CSATCard_choose_resolution === void 0 ? void 0 : CSATCard_choose_resolution.trackingClick) && tracker.click(_objectSpread(_objectSpread({}, CSATCard_choose_resolution.trackingClick), {}, {
      data: _objectSpread(_objectSpread({}, (_CSATCard_choose_reso = CSATCard_choose_resolution.trackingClick) === null || _CSATCard_choose_reso === void 0 ? void 0 : _CSATCard_choose_reso.data), componentTrackingData === null || componentTrackingData === void 0 ? void 0 : (_componentTrackingDat7 = componentTrackingData.CSATCard_choose_resolution) === null || _componentTrackingDat7 === void 0 ? void 0 : (_componentTrackingDat8 = _componentTrackingDat7.trackingItemData) === null || _componentTrackingDat8 === void 0 ? void 0 : _componentTrackingDat8.call(_componentTrackingDat7, {
        is_resolved: value.value
      }))
    }));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('csat-card'))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('csat-card-avatar'))
  }, avatar), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('csat-card-leave-button')),
    onClick: handleClickLeave
  }, trans('label_chatbot_feedback_leave')), /*#__PURE__*/_react.default.createElement("img", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('csat-card-talking-bubble-arrow')),
    src: _bubbleArrow.default
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('csat-card-talking'))
  }, (_trans2 = trans(csatCardTalking)) !== null && _trans2 !== void 0 ? _trans2 : csatCardTalking), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('csat-card-feedback'))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('csat-card-feedback-option'))
  }, /*#__PURE__*/_react.default.createElement(CSATFeedbackOptionItem, {
    text: trans('label_bad_csat'),
    feedbackType: FeedbackType.BAD,
    active: !selectedFeedback || selectedFeedback === FeedbackType.BAD,
    onClick: handleClickFeedBackItem
  }), /*#__PURE__*/_react.default.createElement(CSATFeedbackOptionItem, {
    text: trans('label_average_csat'),
    feedbackType: FeedbackType.AVERAGE,
    active: !selectedFeedback || selectedFeedback === FeedbackType.AVERAGE,
    onClick: handleClickFeedBackItem
  }), /*#__PURE__*/_react.default.createElement(CSATFeedbackOptionItem, {
    text: trans('label_good_csat'),
    feedbackType: FeedbackType.GOOD,
    active: !selectedFeedback || selectedFeedback === FeedbackType.GOOD,
    onClick: handleClickFeedBackItem
  })), keyOptions !== null && keyOptions !== void 0 && keyOptions.length ? /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('csat-card-feedback-key'))
  }, /*#__PURE__*/_react.default.createElement(CSATFeedbackSelector, {
    keyOptions: keyOptions,
    selectedKeys: selectedFeedbackKeys,
    onSelect: handleSelectFeedbackKeys,
    mode: CSATFeedbackSelectorMode.multiple
  })) : null, showInquiryResolved ? /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('csat-card-feedback-inquiry'))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('csat-card-feedback-inquiry-text'))
  }, trans('label_chatbot_feedback_resolved_content')), /*#__PURE__*/_react.default.createElement(CSATFeedbackSelector, {
    keyOptions: InquiryResolvedOptions,
    selectedKeys: selectedInquiryResolve,
    onSelect: handleSelectFeedbackResolvedOptions
  })) : null), showSubmit && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('csat-card-submit'))
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('csat-card-submit-button')),
    type: "primary",
    onClick: handleClickSubmit
  }, trans('label_submit_csat'))));
};
exports.CSATCard = CSATCard;